// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2p3kM","text":"SelectPayment_text__1R_hL","title":"SelectPayment_title__3BTps","btn":"SelectPayment_btn__2KjyW"};